const degrees2Radians = (degrees: number) => degrees * (Math.PI / 180);

export default degrees2Radians;
